import React, { useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { adminRouter } from "./routes/adminRoutes";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from './util/admin/httpAdmin.js';
import ErrorBoundary from './components/shared/ErrorBoundary';
import { SEO_PATHS } from './components/admin/landing/seoPaths';

const getRouter = () => {
    const path = window.location.pathname.split("/")[1]; // Pak eerste segment na "/"
    
    // Lijst van paden die door de adminRouter moeten worden afgehandeld
    const adminPaths = [
        "dashboard", 
        "", 
        "inloggen", 
        "registreren", 
        "logout", 
        "algemene-voorwaarden", 
        "privacy", 
        "contact",
        ...SEO_PATHS.map((p) => p.slice(1)),
    ];
    
    return adminPaths.includes(path) ? adminRouter : null;
};

// De webshop van een zaak zit in een apart bestand, zodat bezoekers van de landingspagina
// die code niet hoeven te downloaden (en omgekeerd laadt een shop het dashboard niet).
const loadCustomerRouter = () =>
    import(/* webpackChunkName: "shop" */ "./routes/customerRoutes").then((m) => m.customerRouter);

const App = () => {
    const [router, setRouter] = useState(getRouter); // Dynamische router selectie

    useEffect(() => {
        if (!router) loadCustomerRouter().then(setRouter);
    }, [router]);

    if (!router) return null;

    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <RouterProvider router={router} />
            </QueryClientProvider>
        </ErrorBoundary>
    );
};

export default App;
